<template>
  <div
    class="dashboard-widget"
    :style="{
      justifyContent: (configs && configs.parameters['Alignment']) || 'center'
    }"
  >
    <span v-show="configs && configs.parameters['Display title']" class="widget-name">{{
      configs && configs.name
    }}</span>
    <loader v-if="loading || !configs"></loader>
    <dashboard-chart-bar
      v-else-if="
        (configs.type === 'charts' || configs.type === 'proc_stats') &&
          configs.parameters['Chart type'] === 'vertical_bar'
      "
      :chart-data="itemsChartBar"
      :configs="configs"
    />
    <dashboard-chart-horizontal-bar
      v-else-if="
        (configs.type === 'charts' || configs.type === 'proc_stats') &&
          configs.parameters['Chart type'] === 'horizontal_bar'
      "
      :chart-data="itemsChartHorizontalBar"
      :configs="configs"
    />
    <dashboard-chart-timeseries
      v-else-if="
        (configs.type === 'charts' || configs.type === 'proc_stats') && configs.parameters['Chart type'] === 'line'
      "
      :chart-data="itemsChartTimeseries"
      :configs="configs"
    />
    <dashboard-chart-doughnut
      v-else-if="
        (configs.type === 'charts' || configs.type === 'proc_stats') && configs.parameters['Chart type'] === 'doughnut'
      "
      :chart-data="itemsChartDoughnut"
      :configs="configs"
    />
    <dashboard-chart-pie
      v-else-if="
        (configs.type === 'charts' || configs.type === 'proc_stats') && configs.parameters['Chart type'] === 'pie'
      "
      :chart-data="itemsChartPie"
      :configs="configs"
    />
    <dashboard-table
      v-else-if="
        configs.type === 'table' ||
          configs.type === 'events_list' ||
          configs.type === 'pivot table' ||
          configs.type === 'od_matrix'
      "
      :items="items"
      :configs="configs"
      :dashboardId="dashboardId"
      @update="id ? update() : rerender()"
    />
    <dashboard-single-value
      v-else-if="configs.type === 'single_value' || configs.type === 'static_text'"
      :items="items"
      :configs="configs"
    />
    <dashboard-date-time
      v-else-if="configs.type === 'filter: date_time'"
      :items="items"
      :configs="configs"
      @apply="updateFilter"
    />
    <dashboard-switch-buttons
      v-else-if="configs.type === 'filter: switch_buttons'"
      :items="items"
      :configs="configs"
      @apply="updateFilter"
    />
    <dashboard-filter-general
      v-else-if="
        configs.type === 'filter: general' ||
          configs.type === 'filter: server_pipeline' ||
          configs.type === 'filter: from_to'
      "
      :items="items"
      :configs="configs"
      @apply="updateFilter"
    />
    <dashboard-face-match
      v-else-if="configs.type === 'face_match'"
      :items="items"
      :configs="configs"
      @apply="updateFilter"
    />
    <dashboard-videostream
      v-else-if="configs.type === 'video_stream'"
      :dashboardId="dashboardId"
      :id="id"
      :items="items"
      :configs="configs"
      @apply="updateFilter"
    />
    <dashboard-flows-and-heatmap
      v-else-if="configs.type === 'flows_heatmap'"
      :dashboardId="dashboardId"
      :id="id"
      :items="items"
      :configs="configs"
    />
    <dashboard-servers-health v-else-if="configs.type === 'servers_health'" :items="items" :configs="configs" />
    <dashboard-videofiles v-else-if="configs.type === 'video_archive'" :items="items" :configs="configs" />
    <div v-else>
      {{ items }}
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import DashboardChartBar from '@/components/DashboardWidgets/DashboardChartBar'
import DashboardChartHorizontalBar from '@/components/DashboardWidgets/DashboardChartHorizontalBar'
import DashboardChartTimeseries from '@/components/DashboardWidgets/DashboardChartTimeseries'
import DashboardChartDoughnut from '@/components/DashboardWidgets/DashboardChartDoughnut'
import DashboardChartPie from '@/components/DashboardWidgets/DashboardChartPie'
import DashboardTable from '@/components/DashboardWidgets/DashboardTable'
import DashboardSingleValue from '@/components/DashboardWidgets/DashboardSingleValue'
import DashboardDateTime from '@/components/DashboardWidgets/DashboardDateTime'
import DashboardSwitchButtons from '@/components/DashboardWidgets/DashboardSwitchButtons'
import DashboardFilterGeneral from '@/components/DashboardWidgets/DashboardFilterGeneral'
import DashboardFaceMatch from '@/components/DashboardWidgets/DashboardFaceMatch'
import DashboardVideostream from '@/components/DashboardWidgets/DashboardVideostream'
import DashboardFlowsAndHeatmap from '@/components/DashboardWidgets/DashboardFlowsAndHeatmap'
import DashboardServersHealth from '@/components/DashboardWidgets/DashboardServersHealth'
import DashboardVideofiles from '@/components/DashboardWidgets/DashboardVideofiles'
export default {
  name: 'DashboardWidget',
  components: {
    Loader,
    DashboardChartBar,
    DashboardChartHorizontalBar,
    DashboardChartTimeseries,
    DashboardChartDoughnut,
    DashboardChartPie,
    DashboardTable,
    DashboardSingleValue,
    DashboardDateTime,
    DashboardSwitchButtons,
    DashboardFilterGeneral,
    DashboardFaceMatch,
    DashboardVideostream,
    DashboardFlowsAndHeatmap,
    DashboardServersHealth,
    DashboardVideofiles
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  props: {
    id: {
      type: String
    },
    temp: {
      type: String,
      default: ''
    },
    dashboardId: {
      type: String
    },
    filterValues: {
      type: Array,
      default: () => []
    },
    settings: undefined,
    elementData: undefined
  },
  data() {
    return {
      loading: false,
      configs: null,
      items: null,
      itemsChartHorizontalBar: null,
      itemsChartPie: null,
      itemsChartDoughnut: null,
      itemsChartTimeseries: null,
      itemsChartBar: null,
      parameters: {},
      disabled: false,
      disabledDrawButtons: false
    }
  },
  watch: {
    id: {
      deep: true,
      immediate: true,
      handler: 'update'
    },
    settings: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  mounted() {
    if (this.settings && this.elementData) {
      this.configs = this.settings
      this.items = this.elementData
      if (this.configs && this.configs.parameters.hasOwnProperty('Chart type')) {
        this.itemsChartHorizontalBar = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartPie = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartDoughnut = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartTimeseries = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartBar = JSON.parse(JSON.stringify(this.elementData))
      }
      this.$forceUpdate()
    }
  },
  methods: {
    updateFilter(values) {
      this.$emit('updateFilter', { id: this.id.replace(this.temp, ''), values })
    },
    rerender() {
      this.configs = this.settings
      this.items = this.elementData
      if (this.configs && this.configs.parameters.hasOwnProperty('Chart type')) {
        this.itemsChartHorizontalBar = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartPie = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartDoughnut = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartTimeseries = JSON.parse(JSON.stringify(this.elementData))
        this.itemsChartBar = JSON.parse(JSON.stringify(this.elementData))
      }
      this.$forceUpdate()
    },
    update() {
      if (this.id && !this.loading) {
        const body = {
          dashboard_id: this.dashboardId,
          element_id: this.id.replace(this.temp, ''),
          filters: JSON.stringify(this.filterValues)
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/dashboard/update?${searchParams}`
        this.loading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.configs = data.config
            this.items = data.ui_element_data
            if (this.configs && this.configs.parameters && this.configs.parameters.hasOwnProperty('Chart type')) {
              this.itemsChartHorizontalBar = JSON.parse(JSON.stringify(this.items))
              this.itemsChartPie = JSON.parse(JSON.stringify(this.items))
              this.itemsChartDoughnut = JSON.parse(JSON.stringify(this.items))
              this.itemsChartTimeseries = JSON.parse(JSON.stringify(this.items))
              this.itemsChartBar = JSON.parse(JSON.stringify(this.items))
            }
            this.$forceUpdate()
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss">
.dashboard-widget {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffffd9;
  border: 1px solid #cccccc;
  padding: 7px;
  .widget-name {
    text-align: center;
    font-weight: bold;
    width: 100%;
    // background-color: white;
  }
  .b-table .table {
    border-radius: 0;
  }
  .field {
    flex-grow: unset;
    &.hidden {
      display: none;
    }
    .field-body {
      flex-grow: unset;
    }
    .field-label {
      // min-width: 8rem;
      padding-top: 0;
      width: 100%;
      .label {
        text-align: right;
        width: 100%;
        // min-width: 6.25rem;
      }
    }
    .control {
      font-size: 1.25em;
      .select {
        min-width: 2rem;
        height: 1.5rem;
        select {
          width: 100%;
          height: 1.5rem;
          padding-top: 0;
          padding-bottom: 0;
          font-size: 0.9rem;
          padding-left: 0.25rem;
          padding-right: 0.25rem;
          &::after {
            right: 0.9rem;
          }
        }
        &:not(.is-multiple):not(.is-loading)::after {
          right: 0.9rem;
        }
      }
      &.datepicker,
      &.timepicker {
        .select {
          vertical-align: middle;
        }
        .icon {
          font-size: 0.9rem;
          height: 1.5rem;
        }
      }
      &.has-icons-right {
        .icon {
          font-size: 0.6875rem;
          right: 0.3125rem;
        }
      }
    }
    .upload.control {
      width: 100%;
      .upload-draggable {
        width: 100%;
        font-size: 0.9em;
      }
    }
    input {
      font-size: 0.9rem;
      height: 1.5rem;
    }
    textarea {
      font-size: 0.9rem;
    }
    .columns {
      margin-right: 0px;
      .column-button {
        padding-right: 0px;
        padding-left: 0px;
        .button {
          width: 100%;
          color: #b032e7;
          border-color: #b032e7;
          font-size: 0.9rem;
          height: 1.5rem;
        }
      }
    }
  }
}
</style>
